import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=bb7445be&scoped=true&"
import script from "./LeftPanel.vue?vue&type=script&lang=js&"
export * from "./LeftPanel.vue?vue&type=script&lang=js&"
import style0 from "./LeftPanel.vue?vue&type=style&index=0&id=bb7445be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7445be",
  null
  
)

export default component.exports